//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import contact from '~/components/forms/contact.vue'
export default {
  components: {
    contact
  },
  computed: {
    ...mapState({
      pages: ({ pagesStore: {pages} }) => pages,
    }),
  },
  async fetch() {
    await Promise.all([ 
      this.$store.dispatch('pagesStore/getPage', 'info-contact')
      ])
  },
  head() {
    return {
      title: this.pages.infocontact ? this.pages.infocontact.seo.title : 'Contact | Info | Secret Circle',
      meta: [
        { hid: 'title', name: 'title', content: this.pages.infocontact ? this.pages.infocontact.seo.title : 'Contact | Info | Secret Circle' },
        { hid: 'og:title', name: 'og:title', content: this.pages.infocontact ? this.pages.infocontact.seo.title : 'Contact | Info | Secret Circle', },
        { hid: 'og:url', name: 'og:url', content: this.$config.feUrl + '/info/contact' },
        { hid: 'og:description', name: 'og:description', content: this.pages.infocontact ? this.pages.infocontact.seo.description : 'Neem contact met ons op.' },
        { hid: 'description', name: 'description', content: this.pages.infocontact ? this.pages.infocontact.seo.description : 'Neem contact met ons op.' },
        { hid: 'keywords', name: 'keywords', content: this.pages.infocontact ? this.pages.infocontact.seo.keywords : 'Contact, bericht'},
        ]
    }
  },
}
